import { SupportedThemes, Theme } from '../../core/tokens/services/theme.service';
import { Colors } from '../../core/tokens/theme/light/ts/colors';

type AvatarSpecificTokenExtract<T> = Extract<T, `colorAvatar${string}`>;
type ExtractedAvatarToken = AvatarSpecificTokenExtract<keyof Theme>;

export type AvatarToken = ExtractedAvatarToken extends never
  ? AvatarSpecificTokenExtract<keyof typeof SupportedThemes.light>
  : ExtractedAvatarToken;

type TextSpecificTokenExtract<T> = Extract<T, `colorText${string}`>;
type ExtractedTextToken = TextSpecificTokenExtract<keyof Theme>;

export type TextToken = ExtractedTextToken extends never
  ? TextSpecificTokenExtract<keyof typeof SupportedThemes.light>
  : ExtractedTextToken;

export type AvatarsTokens = {
  backgroundColor: AvatarToken;
  color: TextToken;
};

export const avatarTokenSet: AvatarsTokens[] = [
  {
    backgroundColor: 'colorAvatarSteelLighter',
    color: 'colorTextOnprimaryDefault',
  },
  {
    backgroundColor: 'colorAvatarSteelLight',
    color: 'colorTextOnprimaryDefault',
  },
  {
    backgroundColor: 'colorAvatarSteelDark',
    color: 'colorTextOnprimaryDefault',
  },

  {
    backgroundColor: 'colorAvatarGreen',
    color: 'colorTextOncomponentDefault',
  },
  {
    backgroundColor: 'colorAvatarBlueLight',
    color: 'colorTextOncomponentDefault',
  },
  {
    backgroundColor: 'colorAvatarBlueDark',
    color: 'colorTextOncomponentDefault',
  },
  {
    backgroundColor: 'colorAvatarPink',
    color: 'colorTextOncomponentDefault',
  },
  {
    backgroundColor: 'colorAvatarPurple',
    color: 'colorTextOncomponentDefault',
  },
  {
    backgroundColor: 'colorAvatarYellow',
    color: 'colorTextOncomponentDefault',
  },
  {
    backgroundColor: 'colorAvatarOrange',
    color: 'colorTextOncomponentDefault',
  },
];

export const avatarColorsSet: any = [
  {
    backgroundColor: Colors.colorAvatarSteelLighter,
    color: Colors.colorTextOnprimaryDefault,
  },
  {
    backgroundColor: Colors.colorAvatarSteelLight,
    color: Colors.colorTextOnprimaryDefault,
  },
  {
    backgroundColor: Colors.colorAvatarSteelDark,
    color: Colors.colorTextOnprimaryDefault,
  },

  {
    backgroundColor: Colors.colorAvatarGreen,
    color: Colors.colorTextOncomponentDefault,
  },
  {
    backgroundColor: Colors.colorAvatarBlueLight,
    color: Colors.colorTextOncomponentDefault,
  },
  {
    backgroundColor: Colors.colorAvatarBlueDark,
    color: Colors.colorTextOncomponentDefault,
  },
  {
    backgroundColor: Colors.colorAvatarPink,
    color: Colors.colorTextOncomponentDefault,
  },
  {
    backgroundColor: Colors.colorAvatarPurple,
    color: Colors.colorTextOncomponentDefault,
  },
  {
    backgroundColor: Colors.colorAvatarYellow,
    color: Colors.colorTextOncomponentDefault,
  },
  {
    backgroundColor: Colors.colorAvatarOrange,
    color: Colors.colorTextOncomponentDefault,
  },
];
